// extracted by mini-css-extract-plugin
module.exports = {"exam_result_root_wrapper":"ExamResult_exam_result_root_wrapper__2QkZl"};